export const getClassNames = (...classes: string[]): string => classes.filter(Boolean).join(' ');